export const Encapsulation = {
  shadowDom: 'shadowDom',
  none: 'none',
} as const
